"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicationStatusColumn = exports.sourceTypeColumn = exports.questionTypeColumn = exports.LibraryQuestionColumnHelper = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../components/common");
var contentConstants_1 = __importDefault(require("../../contentConstants"));
var ColumnHelper_1 = require("./ColumnHelper");
var DimensionViewColumnHelper_1 = require("./DimensionViewColumnHelper");
var getSurveyQuestionColumns = function () {
    return [
        addToSurveyColumn,
        questionIdColumn,
        dimensionColumn,
        exports.questionTypeColumn,
        questionTextColumn,
        responseOptionColumn,
        questionTemplateColumn,
        altVersionsColumn,
        tagsColumn,
        allEnabledLanguagesColumn,
        allEnabledBenchmarksColumn,
    ];
};
var getDimensionListQuestionColumns = function () {
    return [
        questionIdColumn,
        exports.questionTypeColumn,
        questionTextColumn,
        questionTemplateColumn,
        altVersionsColumn,
        responseOptionColumn,
        tagsColumn,
        __assign(__assign({}, altVersionsColumn), { checked: true, displayOrder: 8 }),
        __assign(__assign({}, DimensionViewColumnHelper_1.languagesColumn), { displayOrder: 9 }),
        __assign(__assign({}, allEnabledLanguagesColumn), { checked: false }),
        allEnabledBenchmarksColumn,
    ];
};
var getDimensionQuestionColumnsWithTranslations = function () {
    return [
        addToDimensionColumn,
        questionIdColumn,
        exports.questionTypeColumn,
        questionTextColumn,
        questionTemplateColumn,
        altVersionsColumn,
        dimensionColumn,
        tagsColumn,
        DimensionViewColumnHelper_1.languagesColumn,
    ];
};
var getDimensionQuestionColumns = function () {
    return [
        addToDimensionColumn,
        questionIdColumn,
        questionTextColumn,
        __assign(__assign({}, responseOptionColumn), { checked: false, disabled: false }),
        dimensionColumn,
        __assign(__assign({}, exports.questionTypeColumn), { checked: false, disabled: false }),
        exports.sourceTypeColumn,
        questionTemplateColumn,
        altVersionsColumn,
        tagsColumn,
        DimensionViewColumnHelper_1.languagesColumn,
        allEnabledBenchmarksColumn,
    ];
};
var getDemographicQuestionColumns = function () {
    return [
        addToSurveyColumn,
        questionIdColumn,
        questionTextColumn,
        responseOptionColumn,
        mappedAttributeColumn,
        tagsColumn,
        allEnabledLanguagesColumn,
    ];
};
var getColumnHeaders = function (selectedColumns) {
    // The selectedColumns arg may be managed by redux, so do not mutate that collection.
    var sortedColumns = __spreadArray([], selectedColumns, true).sort(function (a, b) { return a.displayOrder - b.displayOrder; });
    var columnHeaders = ColumnHelper_1.ColumnHelper.GetColumnHeaders(sortedColumns);
    columnHeaders.forEach(function (columnHeader) {
        if (columnHeader.field === mappedAttributeColumn.name) {
            columnHeader.tooltipContent = (React.createElement(common_1.TooltipContentWrapper, null,
                React.createElement(common_1.TooltipContentTitle, null, contentConstants_1.default.MAPPED_ATTRIBUTE_TOOLTIP_TITLE),
                React.createElement("div", null, contentConstants_1.default.MAPPED_ATTRIBUTE_TOOLTIP_BODY)));
        }
    });
    return columnHeaders;
};
exports.LibraryQuestionColumnHelper = {
    getSurveyQuestionColumns: getSurveyQuestionColumns,
    getDemographicQuestionColumns: getDemographicQuestionColumns,
    getColumnHeaders: getColumnHeaders,
    getDimensionQuestionColumns: getDimensionQuestionColumns,
    getDimensionQuestionColumnsWithTranslations: getDimensionQuestionColumnsWithTranslations,
    getDimensionListQuestionColumns: getDimensionListQuestionColumns,
};
var addToDimensionColumn = {
    displayText: 'Add to Dimension',
    name: 'isSelected',
    checked: true,
    displayOrder: 1,
    disabled: true,
    sortAscByDefault: true,
    isSortable: true,
};
var addToSurveyColumn = {
    displayText: 'Add to Survey',
    name: 'isSelected',
    checked: true,
    displayOrder: 1,
    disabled: true,
    sortAscByDefault: true,
    isSortable: true,
};
var questionIdColumn = {
    displayText: 'Question ID',
    name: 'code',
    checked: false,
    displayOrder: 2,
    sortAscByDefault: true,
    isSortable: true,
    disabled: false,
};
var questionTextColumn = {
    displayText: 'Question',
    name: 'text',
    checked: true,
    displayOrder: 3,
    disabled: true,
    sortAscByDefault: true,
};
var responseOptionColumn = {
    displayText: 'Response Option',
    name: 'responseOptionGroup',
    checked: true,
    displayOrder: 4,
    disabled: true,
};
var dimensionColumn = {
    displayText: 'Dimensions',
    name: 'dimensions',
    checked: true,
    displayOrder: 5,
    sortAscByDefault: true,
    isSortable: true,
    disabled: false,
};
exports.questionTypeColumn = {
    displayText: 'Question Type',
    name: 'questionType',
    checked: true,
    displayOrder: 6,
    disabled: true,
};
exports.sourceTypeColumn = {
    displayText: 'Source',
    name: 'sourceType',
    checked: true,
    displayOrder: 7,
    disabled: true,
};
exports.publicationStatusColumn = {
    displayText: 'Status',
    name: 'publicationStatus',
    checked: true,
    displayOrder: 8,
    disabled: true,
    sortAscByDefault: false,
    isSortable: false,
};
var mappedAttributeColumn = {
    displayText: 'Mapped Attribute',
    name: 'mappedAttribute',
    checked: true,
    displayOrder: 8,
    disabled: false,
};
var questionTemplateColumn = {
    displayText: 'Question Template',
    name: 'questionTemplates',
    checked: false,
    displayOrder: 9,
    disabled: false,
};
var altVersionsColumn = {
    displayText: 'Alt Versions',
    name: 'alternateVersions',
    checked: false,
    displayOrder: 10,
    disabled: false,
};
var tagsColumn = {
    displayText: 'Tags',
    name: 'tags',
    checked: false,
    displayOrder: 11,
    disabled: false,
};
var allEnabledLanguagesColumn = {
    displayText: 'All Enabled Languages',
    name: 'allChosenLanguages',
    checked: true,
    displayOrder: 12,
    disabled: false,
    sortAscByDefault: false,
};
var allEnabledBenchmarksColumn = {
    displayText: 'All Enabled Benchmarks',
    name: 'allChosenBenchmarks',
    checked: false,
    displayOrder: 14,
    disabled: false,
    sortAscByDefault: false,
};
